import {availableFobBettingTypesFor, fobBettingSubTypesFor, fobBettingTypeLabel} from "../fob.betting/fob-catalog";
import {Hippodrome} from "../../../models/bulletin.models";
import {BettingTypesMap} from "../../../features/core/definitions";
import React from "react";

import {isMobile} from "../../../App";

// FOB sayfasının tür / koşu seçenekleri. Seçim bağlamı sayfadan PROP olarak geliyor
// (eskiden modül seviyesindeki `fobPageSelection` globalini okuyordu).
export function BettingFobTypeOptions(props: any) {

    const selection = props.selection;
    const setOpenCustomizeModal = props.setOpenCustomizeModal;
    const hippodrome: Hippodrome = props.hippodrome;
    const availableBettingTypes: any = availableFobBettingTypesFor(hippodrome);
    const selectBettingType = props.selectBettingType;
    const selectBettingSubType = props.selectBettingSubType;

    const pushFilter = (value: any) => {
        try {
            // @ts-ignore
            dataLayer.push({
                event: "filter",
                ganyan_type: value,
                kosu_type: selection.bettingSubType?.label,
                hippodrome: selection.hippodrome?.hippodrome
            });
        } catch (e) {
        }
    };

    const typeSelect = (
        <select onChange={(e: any) => {
            selectBettingType(e.target.value);
            pushFilter(e.target.value);
        }} value={selection.bettingType.id} className={"betting-select w-100"}>
            {availableBettingTypes.map((bettingType: any, keyBettingType: number) => {
                return (
                    <option key={`keyBettingType-${keyBettingType}`}
                            value={bettingType.id}>{fobBettingTypeLabel(bettingType)}</option>)
            })}
        </select>
    );

    const subTypeSelect = (labelPrefix: string) => (
        <select className={"betting-select w-100"} onChange={(e: any) => {
            selectBettingSubType(e.target.value);
            pushFilter(e.target.value);
        }} value={selection.bettingSubType.id}>
            {fobBettingSubTypesFor(hippodrome, selection.bettingType).map((bettingSubType: any, keyBettingSubType: number) => {
                return (<option key={`keyBettingType-${keyBettingSubType}`}
                                value={bettingSubType.id}>{labelPrefix}{bettingSubType.label}</option>)
            })}
        </select>
    );

    return (<div className="">
        {isMobile ? <>
                <div className="mobile-filter-wrapper">

                    {selection.bettingType && selection.bettingType.id !== 0 && typeSelect}
                    {selection.bettingSubType && selection.bettingType?.id !== 0 && !!BettingTypesMap[Number(selection.bettingType?.id)]?.isFobPairPick &&
                        subTypeSelect('')}
                </div>

            </>
            : <div className="row pt-2">

                <div className="col-6 col-lg-3 p-0 pe-1">
                    {selection.bettingType && typeSelect}
                </div>
                <div className="col-6 col-lg-3 p-0 pe-1">
                    {selection.bettingSubType && subTypeSelect('Koşu - ')}
                </div>


                <div className="col-8 col-lg-6 p-0 ">
                    <a className={`btn-link cursor-pointer`} style={{minHeight: '44px'}} onClick={() => {
                        setOpenCustomizeModal(true);
                    }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 15 14" fill="none">
                            <path
                                d="M3.58325 1.16659C3.58325 0.844419 3.32208 0.583252 2.99992 0.583252C2.67775 0.583252 2.41659 0.844419 2.41659 1.16659V2.04159H1.54159C1.21942 2.04159 0.958252 2.30275 0.958252 2.62492C0.958252 2.94708 1.21942 3.20825 1.54159 3.20825H2.41659V4.08325C2.41659 4.40542 2.67775 4.66659 2.99992 4.66659C3.32208 4.66659 3.58325 4.40542 3.58325 4.08325V3.20825H4.45825C4.78042 3.20825 5.04159 2.94708 5.04159 2.62492C5.04159 2.30275 4.78042 2.04159 4.45825 2.04159H3.58325V1.16659Z"
                                fill="#1F3735">
                            </path>
                            <path
                                d="M3.58325 9.91659C3.58325 9.59442 3.32208 9.33325 2.99992 9.33325C2.67775 9.33325 2.41659 9.59442 2.41659 9.91659V10.7916H1.54159C1.21942 10.7916 0.958252 11.0528 0.958252 11.3749C0.958252 11.6971 1.21942 11.9583 1.54159 11.9583H2.41659V12.8333C2.41659 13.1554 2.67775 13.4166 2.99992 13.4166C3.32208 13.4166 3.58325 13.1554 3.58325 12.8333V11.9583H4.45825C4.78042 11.9583 5.04159 11.6971 5.04159 11.3749C5.04159 11.0528 4.78042 10.7916 4.45825 10.7916H3.58325V9.91659Z"
                                fill="#1F3735">
                            </path>
                            <path
                                d="M8.5027 1.54051C8.41606 1.31524 8.19962 1.16659 7.95825 1.16659C7.71689 1.16659 7.50045 1.31524 7.4138 1.54051L6.4022 4.17068C6.22696 4.62629 6.1719 4.75759 6.09658 4.86351C6.021 4.9698 5.92813 5.06267 5.82185 5.13824C5.71592 5.21356 5.58463 5.26863 5.12902 5.44386L2.49885 6.45547C2.27357 6.54211 2.12492 6.75855 2.12492 6.99992C2.12492 7.24129 2.27357 7.45773 2.49885 7.54437L5.12902 8.55597C5.58463 8.73121 5.71592 8.78627 5.82185 8.8616C5.92814 8.93717 6.021 9.03004 6.09658 9.13632C6.1719 9.24225 6.22696 9.37354 6.4022 9.82915L7.4138 12.4593C7.50045 12.6846 7.71689 12.8333 7.95825 12.8333C8.19962 12.8333 8.41606 12.6846 8.5027 12.4593L9.51431 9.82915C9.68954 9.37354 9.74461 9.24225 9.81993 9.13632C9.89551 9.03004 9.98837 8.93717 10.0947 8.8616C10.2006 8.78627 10.3319 8.73121 10.7875 8.55597L13.4177 7.54437C13.6429 7.45773 13.7916 7.24129 13.7916 6.99992C13.7916 6.75855 13.6429 6.54211 13.4177 6.45547L10.7875 5.44386C10.3319 5.26863 10.2006 5.21356 10.0947 5.13824C9.98837 5.06267 9.89551 4.9698 9.81993 4.86351C9.74461 4.75759 9.68954 4.62629 9.51431 4.17068L8.5027 1.54051Z"
                                fill="#1F3735">
                            </path>
                        </svg>
                        <span className={"text-xsmall fw-medium text-green"}>ORANLAR</span>
                    </a>
                </div>


            </div>}
    </div>)
}
